import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';
import Notification from 'src/shared/app/notification/component/Notification';
import type { Notification as NotificationType } from 'src/shared/app/notification/type/notificationTypes';
import messages from 'src/shared/app/preference/l10n/preferenceNotificationsL10n';

type Props = {
  notification: NotificationType<{}>;
};

const NotificationPreferencesSuccessBanner = ({ notification }: Props) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const handleDismiss = () => {
    dispatch(dismissNotification(notification));
  };

  return (
    <Notification timeout={4000} handleDismiss={handleDismiss}>
      {intl.formatMessage(messages.saved)}
    </Notification>
  );
};

export default NotificationPreferencesSuccessBanner;
